"use client"
import { createSvgIcon, useTheme } from "@mui/material"
import type { IconProps } from "../types"
import { getPath } from "../utils"

const Upload = createSvgIcon(
  <path d="M6.5 19C5.25257 19 4.19071 18.5662 3.31442 17.6986C2.43814 16.831 2 15.7705 2 14.5173C2 13.3327 2.40769 12.3058 3.22308 11.4365C4.03846 10.5673 4.99615 10.1 6.09615 10.0346C6.32052 8.5782 6.99039 7.375 8.10577 6.425C9.22116 5.475 10.5192 5 12 5C13.6714 5 15.0893 5.58214 16.2536 6.74642C17.4179 7.91071 18 9.32857 18 11V12H18.6154C19.5731 12.0308 20.3766 12.3824 21.026 13.0548C21.6753 13.7272 22 14.5423 22 15.5C22 16.4808 21.6683 17.3093 21.0048 17.9856C20.3414 18.6619 19.5192 19 18.5385 19H13.1154C12.6551 19 12.2708 18.8458 11.9625 18.5375C11.6542 18.2292 11.5 17.8449 11.5 17.3846V11.5808L9.4 13.6692L8.6923 12.9808L12 9.67307L15.3077 12.9808L14.6 13.6692L12.5 11.5808V17.3846C12.5 17.5385 12.5641 17.6795 12.6923 17.8077C12.8205 17.9359 12.9615 18 13.1154 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.46155C5.53333 11 4.72436 11.3417 4.03462 12.025C3.34487 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18H9V19H6.5Z" />,
  "Upload",
)

const UploadIcon = (props: IconProps) => {
  const { fill, sx, ...rest } = props
  const theme = useTheme()
  const _fill =
    (fill && getPath(theme.palette, fill)) || theme.palette.text.primary

  return <Upload sx={{ fill: _fill, ...sx }} {...rest} />
}

export default UploadIcon
